export const environment = {
  gameMode: 'janko'
};
